



















import { defineComponent } from '@vue/composition-api';

const name = 'ttam-ad-list-buttons';

export default defineComponent({
  name,

  props: {
    visible: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    disabledHint: { type: String, default: '' },
  },

  setup(props, { emit }) {
    function onAdd() {
      emit('add');
    }

    return {
      onAdd,
    };
  },
});
